// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EN7F","controls":"styles_controls__2eGPK","charLimit":"styles_charLimit__3LfGy","input":"styles_input__1tSfL","send":"styles_send__1XYer"};